import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import PageTitle from "common/web/PageTitle";
import { RouteProps } from "./routes-path";
import { useApplication } from "../../../../application/store";
import { Application } from "../../../../application/view";

type PropsType = RouteComponentProps<RouteProps> & WithStyles<typeof styles>;

const Prihlaska = (props: PropsType) => {

    const { classes } = props;
    const [state] = useApplication();
    const { applicationId, hashCode, lang } = props.match.params;

    const id = Number(applicationId);


    React.useEffect(() => {

        if (state.entity.id && state.entity.hashCode) {

            const encodedEntityHashCode = encodeURIComponent(state.entity.hashCode.split('/').join(' ').split('+').join('_'));

            if (!applicationId || (hashCode && hashCode !== encodedEntityHashCode)) {
                const url = props.match.path.replace(':lang', lang)
                    .replace(':applicationId?', state.entity.id.toString())
                    .replace(':hashCode?', encodedEntityHashCode);

                props.history.push(url);
            }

        }

    }, [state.entity.hashCode]);



    return <div>
        <PageTitle title="Přihláška ke členství" />
        <div className={classes.content}>
            <Application applicationId={isNaN(id) ? undefined : id} hashCode={hashCode} />
        </div>
    </div>;
};


const styles = (theme: Theme) => createStyles({
    content: {
        padding: 2 * theme.spacing.unit,
    },
});

export default withStyles(styles)(withRouter(Prihlaska));